import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=32b58682"
import script from "./SpecialOffers.vue?vue&type=script&lang=js"
export * from "./SpecialOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports